(function() { window.GUID_865489e1_07c4_488c_9c36_4c2ecf337ac8 = { getGuid: function() { return "865489e1-07c4-488c-9c36-4c2ecf337ac8"; } }; })();
let printingDiagnostic = $('#PrintingDiagnostic');
if (printingDiagnostic.length > 0) {
    BindActionOfPrintDiag(null, printingDiagnostic, null, null);
}
$(function () {
    CS.FormReady(function (formId) {
        if (formId == "SelectStartInstance") {
            var btnInstallWPF = $('#BtnInstallWPF');
            if (btnInstallWPF != null) {
                btnInstallWPF.off('click');
                btnInstallWPF.on('click', function (e) {
                    e.preventDefault();
                    CompuSport.Ajax.Get(CSParameters.RUrl + "InstallWpf/Download/" + CSParameters.SportEventId, null, function (response) { });
                });
            }
        }
    });
});
function RefreshPrintDiag(printingDiagnostic, data, controllername, callback) {
    CompuSport.Ajax.Post(CSParameters.RUrl + "SportEvents/GetPrintDiagnostic/" + CSParameters.SportEventId, data, function (response) {
        var body = $('body');
        var printingDiagnostic = $('#PrintingDiagnostic', body);
        if (printingDiagnostic.length == 0) {
            if (response.printingDiag != "") {
                body.append(response.printingDiag);
                printingDiagnostic = $('#PrintingDiagnostic', body);
                BindActionOfPrintDiag(controllername, printingDiagnostic, data, callback);
                printingDiagnostic.slideDown();
            }
        }
        else {
            if (response.printingDiag != "") {
                printingDiagnostic.find("#PrintingDiagnosticContainer").replaceWith($(response.printingDiag).find("#PrintingDiagnosticContainer"));
                printingDiagnostic.slideDown();
            }
            else {
                printingDiagnostic.slideUp();
            }
        }
    });
}
function BindActionOfPrintDiag(controllername, printingDiagnostic, data, callback) {
    printingDiagnostic.off('click');
    printingDiagnostic.on('click', function (e) {
        var target = $(e.target);
        if (target.hasClass("ClosePrintingDiagnostic")) {
            printingDiagnostic.slideUp();
        }
        else if (target.hasClass("NotUsingPrintintOptions")) {
            //logguer le fix it button.
            if (data == null) {
                data = {};
            }
            CompuSport.Ajax.Post(CSParameters.RUrl + "PrinterQueues/NotUsingPrintintOptions/" + CSParameters.SportEventId, null, function (queryResult) {
                printingDiagnostic.slideUp();
                RefreshPrintDiag(printingDiagnostic, data, controllername, callback);
            });
        }
        else if (target.hasClass("ClickHereToSeeHowToFix")) {
            CompuSport.Ajax.Post(CSParameters.RUrl + "PrinterQueues/LogFixItButton/" + CSParameters.SportEventId, { FixUrl: target.parent().attr("data-url") }, function (response) { });
            if (target.parent().attr("data-GetOrPost") == "GET") {
                var popupUrl = target.parent().attr("data-url");
                if (controllername == 'SurfacesScheduler' || controllername == 'Schedules') {
                    popupUrl = popupUrl.replace('SurfacesScheduler', controllername);
                }
                data.Post = true;
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "PrintDiag",
                    Url: popupUrl,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
                popup.OnPosted = function (result) {
                    //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                    if ($('form', result).length == 0) {
                        RefreshPrintDiag(printingDiagnostic, data, controllername, callback);
                        if (callback != null) {
                            callback.call(this, result);
                        }
                    }
                };
                /*
                ShowFormPopup(popupUrl, data, null, function (result) {
                    //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                    if ($('form', result).length == 0) {
                        $(this).dialog('close');
                        RefreshPrintDiag(printingDiagnostic, data, controllername, callback);
                        if (callback != null) {
                            callback.call(this, result);
                        }
                    }
                });
                */
            }
            else {
                CompuSport.Ajax.Post(target.parent().attr("data-url"), null, function (queryResult) {
                    printingDiagnostic.slideUp();
                    RefreshPrintDiag(printingDiagnostic, data, controllername, callback);
                });
            }
        }
    });
}
function ForcePrint(data, controllername, callback, refreshRowCallBack) {
    let retValue = "";
    CompuSport.Ajax.Post(CSParameters.RUrl + controllername + "/ForcePrintSelected/" + CSParameters.SportEventId, data, function (response) {
        retValue = response;
        if (refreshRowCallBack != null) {
            refreshRowCallBack.call(this, retValue);
        }
        if (callback == null && retValue != null && retValue != "") {
            CompuSport.Controls.Popup.ShowWarningDialog(retValue);
        }
        RefreshPrintDiag(null, data, controllername, callback);
    });
    return retValue;
}

//# sourceMappingURL=PrinterDiagnostic.desktop.js.map
